// lib/history-updater.ts
import type { HistoryItem } from '@/components/sidebar-history';

let addNewHistoryItem: ((item: HistoryItem) => void) | null = null;

export function setAddNewHistoryItem(fn: (item: HistoryItem) => void) {
  addNewHistoryItem = fn;
}

export function addHistoryItem(item: HistoryItem) {
  if (addNewHistoryItem) {
    addNewHistoryItem(item);
  }
}
